/**
 * HTML Export Plugin for Lexical Editor
 * Exports editor content as HTML whenever it changes
 */
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $generateHtmlFromNodes } from '@lexical/html';
import { useEffect } from 'react';

function useSafeLexicalComposerContext() {
    try {
        return useLexicalComposerContext();
    } catch (e) {
        console.warn('LexicalComposerContext not found in HtmlExportPlugin:', e);
        return [null];
    }
}

export default function HtmlExportPlugin({ onChange }) {
    const [editor] = useSafeLexicalComposerContext();

    useEffect(() => {
        if (!editor) {
            return;
        }

        return editor.registerUpdateListener(({ editorState }) => {
            editorState.read(() => {
                const html = $generateHtmlFromNodes(editor, null);
                if (onChange) {
                    onChange(html);
                }
            });
        });
    }, [editor, onChange]);

    return null;
}
